import React, { useState } from 'react';
import questionIcon from '../../assets/icons/DashboardIcons/question.svg';
import productIcon from '../../assets/icons/DashboardIcons/product.svg';
import Button from '../global/Button';

type TopProductCardProps = {
  type?: 'mobile';
};
const TopProductCard = ({ type }: TopProductCardProps) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className={`${!type && 'border-[#DDDDDD] rounded-md border px-3'} py-3 `}>
      <div className='space-y-4'>
        <div className='flex items-center pl-2 justify-between   space-x-3'>
          <h2 className='font-normal font-poppins text-xs text-[#212121]'>Top products</h2>
          <div className='flex flex-col items-end relative gap-2'>
            <div className='cursor-pointer' onClick={() => setShowTooltip(!showTooltip)}>
              {!type && <img src={questionIcon} alt='question-icon' />}
            </div>

            {showTooltip && (
              <div className='w-[248px] h-[78px] absolute top-6 z-50 justify-end transition-all pb-1 bg-white rounded-md shadow-smYellow'>
                <p className='font-poppins text-xs  pt-3 pl-3 pr-6 '>
                  These are the lists of your top selling products.
                </p>
                <div className='flex justify-end pr-4 pt-[6px] '>
                  <button
                    onClick={() => setShowTooltip(!showTooltip)}
                    className='text-green font-normal text-xs font-poppins'
                  >
                    Close
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
        {!type && <div className='border-b-[1px]  border-[#CDD5D5]'></div>}
        <div className='flex justify-center items-center md:block'>
          <img src={productIcon} alt={productIcon} />
        </div>
        <div className='flex-cols text-center md:flex items-center justify-between'>
          <p className='text-base text-[#212121] font-poppins font-normal md:text-[9.95px]'>
            You do not have any products and transaction.
          </p>
          <Button className='text-xs  font-poppins !px-4 !py-2'>Add product</Button>
        </div>
      </div>
    </div>
  );
};

export default TopProductCard;
